import { AppConfig } from '../app-config'

const isIxigoPartnersSite = () => {
	return AppConfig.domain_url?.includes('ixigo') ? true : false
}

export default isIxigoPartnersSite
